<template>
    <div>
        <load-mask />
        <barra-navegacao v-if="dia!=0" @proximo="proximo" @anterior="anterior">
            <table align="center" class="table" border="0" cellspancing="0">
                <tr>
                    <td rowspan="2" class="dia" onclick="document.querySelector('.vdatetime-input').focus()">{{dia}}</td>
                    <td  height="20px" valign="bottom" align="center" onclick="document.querySelector('.vdatetime-input').focus()">{{diasemana}}</td>
                </tr>
                <tr>
                    <td  height="20px" valign="top" align="center" onclick="document.querySelector('.vdatetime-input').focus()">{{mes}} {{ano}}</td>
                </tr>
            </table>
        </barra-navegacao>


        <div class="item-lembrete" v-for="item in lembretes" v-bind:key="item.DataLembrete">
         {{ limpaHref(item.ItemLembrete)  }}
        </div>

        
        <datetime v-on:input="teste" v-model="datamodal"/>


    </div>
</template>


<script>

import moment from 'moment';

import LoadMask from '@/views/LoadMask.vue';
import BarraNavegacao from '@/components/shared/BarraNavegacao.vue';
import request from '@/services/services.js';
import {nomedomes, diasemana} from '@/services/dateutils.js';
import { Datetime } from 'vue-datetime';


export default {
    name: 'Lembretes',
    components : {
        LoadMask,
        BarraNavegacao,
        Datetime


    },
    data(){
        return {
            data: new Date(),
            datamodal: null,
            dia : 0,
            mes : '',
            diasemana : '',
            ano : 0,
            lembretes : []
        }
    },


    mounted : function(){



        this.carregaLembrete();
        

    },

    methods : {

        teste(){

            if(this.datamodal){

                this.data = new Date(this.datamodal);
                this.carregaLembrete();

            }
            //


        },

        anterior(){
            this.data.setDate(this.data.getDate()-1);
            this.carregaLembrete();
        },
        proximo(){
            this.data.setDate(this.data.getDate()+1);
            this.carregaLembrete();
        },

        carregaLembrete(){

        
            var strData = moment(this.data).format('DD/MM/YYYY');

            this.dia = this.data.getDate();
            this.mes = nomedomes(this.data.getMonth());
            this.ano = this.data.getFullYear();

            this.diasemana = diasemana(this.data.getDay());


            request(this, 'GET',
                'Mobile_GetLembretes',
                `id_usuario=${this.$root.getUsuario()}&dt_base=${encodeURIComponent(strData)}`)
                    .then(res => {
                        if(res){

                            this.lembretes = res;

                        }
                    });
        },

        limpaHref(lembrete){


            if(lembrete.indexOf("<a")!=-1){

                var retorno = lembrete.substring(
                    lembrete.indexOf('>') + 1, 
                    lembrete.lastIndexOf('</a>')
                );
                
                return retorno;

            } else {
                return lembrete;
            }

        }

    }
}
</script>

<style scoped>
.table{
    color: white;
    font-size: 14px;
    line-height: 12px;
}
.dia{
    font-size: 30px;
}
</style>